<mn-amount
  [round]="false"
  [prefix]="prefix()"
  [amount]="amount()"
  [precision]="precision()"
  [min]="min()"
  (amountChange)="amountChange.emit($event)">
  <mn-button size="small" left aEvent="calculator_preset_min" (clicked)="onMinClick()"
    ><span class="c-20 t-xs u-c">{{ "btn.min" | mnTranslate }}</span>
  </mn-button>
  <mn-button size="small" right aEvent="calculator_preset_max" (clicked)="onMaxClick()"
    ><span class="c-20 t-xs u-c">{{ "btn.max" | mnTranslate }}</span>
  </mn-button>
</mn-amount>
<div class="lines f-c">
  @for (group of bG; track $index) {
    <div class="line">
      @for (btn of group; track $index) {
        <mn-button
          size="large"
          class="d-xs c-20"
          [type]="btn.icon ? 'yellow' : 'default'"
          [aEvent]="'calculator_btn_' + btn.event"
          (clicked)="btn.fn()">
          @if (btn.icon) {
            <mn-svg [name]="btn.icon" />
          } @else {
            <span>{{ btn.text }}</span>
          }
        </mn-button>
      }
    </div>
  }
</div>
